import { Notification } from './Notification';
export class NotificationsSearchModel {
    pageData: Notification[];
    pageNumber = 0;
    pageSize = 0;
    unSeenNotificationsCount: number;
    totalCount: number;
}
